<template>
  <div>
    <Header>
      Edycja użytkownika: {{ user.name }}
    </Header>

    <b-row>
      <b-col xl="6">
        <Errors/>

        <b-form @submit.prevent="submit">
          <b-form-group label="Nazwa">
            <b-input v-model="form.name" required :disabled="user.is_root"/>
          </b-form-group>
          <b-form-group label="Login">
            <b-input v-model="form.login" required :disabled="user.is_root"/>
          </b-form-group>
          <b-row>
            <b-col xl="6">
              <b-form-group label="Nowe hasło">
                <b-input v-model="form.password" type="password" autocomplete="new-password"/>
              </b-form-group>
            </b-col>
            <b-col xl="6">
              <b-form-group label="Powtórz nowe hasło">
                <b-input v-model="form.password_confirm" type="password" autocomplete="new-password"/>
              </b-form-group>
            </b-col>
          </b-row>
          <b-form-group label="Rola">
            <b-select v-model="form.role" :options="select_roles" :disabled="user.is_root"/>
          </b-form-group>
          <b-form-group>
            <div class="d-flex justify-content-between">
              <div>
                <inertia-link
                  :href="route('users.index')"
                  as="b-button"
                  variant="secondary"
                >
                  <b-icon icon="x"/>
                  Anuluj
                </inertia-link>
                <b-button
                  v-if="!user.is_root"
                  :variant="!user.deleted_at ? 'danger' : 'success'"
                  :disabled="formDelete.processing || auth.user.id === user.id"
                  @click="deleteUser"
                >
                  <b-icon v-if="!user.deleted_at" icon="trash"/>
                  <b-icon v-else icon="arrow-clockwise"/>
                </b-button>
              </div>
              <div>
                <b-button type="submit" variant="primary" :disabled="form.processing">
                  <b-icon icon="check"/>
                  Zapisz
                </b-button>
              </div>
            </div>
          </b-form-group>
        </b-form>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import _ from 'lodash'
import Layout from '@/Layouts/Default'
import Header from '@/Layouts/Components/Header'
import Errors from "../../Layouts/Components/Errors";

export default {
  layout: Layout,
  components: {
    Errors,
    Header,
  },
  props: {
    user: Object,
  },
  data() {
    return {
      form: this.$inertia.form({
        name: this.user.name || '',
        login: this.user.login || '',
        role: this.user.role || 'user',
        password: '',
        password_confirm: '',
      }),
      formDelete: this.$inertia.form({}),
    }
  },
  computed: {
    auth() {
      return this.$page.props.auth
    },
    select_roles() {
      return [
        {value: 'user', text: 'Użytkownik'},
        {value: 'moderator', text: 'Moderator'},
        {value: 'admin', text: 'Admin'},
      ]
    },
  },
  methods: {
    submit() {
      this.form
        .transform((data) => _.pickBy(data))
        .put(this.route('users.update', this.user.id))
    },
    deleteUser() {
      this.formDelete.delete(this.route('users.destroy', this.user.id))
    },
  },
}
</script>
